import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../shared/material.module'
import { SharedModule } from '../../../shared/shared.module'
import { RebateClaimsDetailsComponent } from './rebate-claims-details.component'

@NgModule({
  declarations: [RebateClaimsDetailsComponent],
  imports: [CommonModule, RouterModule, UrlModule, SharedModule, MaterialModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        RebateClaimDetailsComponent: {
          component: RebateClaimsDetailsComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class RebateClaimsDetailsModule {}
